import React, { useEffect } from "react";
import { getCountryLinksByRegion } from "./utils";
import { useAccountContext } from "./AccountContextProvider";
import { Button, Icon, Sheet, ThemeProvider } from "@amzn/storm-ui";
import { angleLeft, angleRight, spinner } from "@amzn/storm-ui-icons";
import { AccountInfoCard } from "./AccountInfoCard";
import { CountryLinksSection } from "./CountryLinksSection";
import { useBundle } from "@amzn/react-arb-tools";
import {
  MobileCloseBtnContainer,
  MobileCloseBtnText,
  MobileCloseIcon,
  MobileListComponentContainer,
  MobileSheetContentContainer,
} from "src/components/styles/SelectorComponentStyling";

export const CountrySelectorMobile: React.VFC = () => {
  const {
    selectedAccount,
    selectedAccountType,
    setSelectedAccount,
    selectedAccountRef,
    setPreSelectedAccount,
  } = useAccountContext();
  const countryLinksWithRegionArr = getCountryLinksByRegion(selectedAccount);
  const pageDirection = document.documentElement.dir;

  useEffect(() => {
    if (selectedAccount) {
      // Keep bottom layer from scrolling to the top
      document.body.style.top = `-${window.scrollY}px`;
      document.body.style.position = "fixed";
    } else {
      // Maintain the original location where user was before opening country selector
      const scrollY = document.body.style.top;
      document.body.style.position = "";
      document.body.style.top = "";
      window.scrollTo(0, parseInt(scrollY || "0") * -1);
    }
  }, [selectedAccount]);

  const handleClose = () => {
    setSelectedAccount(undefined);
    setPreSelectedAccount(undefined);
    const selectedAccountLink = selectedAccountRef.current
      ?.children[0] as HTMLElement;
    selectedAccountLink.focus();
  };

  const [bundle, isBundleLoading] = useBundle("pages.interstitial");

  if (isBundleLoading) {
    return <Icon type={spinner}></Icon>;
  }

  const cancelLabel = bundle.getMessage("cancel");

  const overrideModalZIndex = (theme) => ({
    ...theme,
    modal: {
      ...theme.modal,
      zIndex: 799,
    },
  });

  return (
    <ThemeProvider theme={overrideModalZIndex}>
      <Sheet
        isOpen={selectedAccount !== undefined}
        onClose={handleClose}
        side="start"
        withCloseButton={false}
        padding="none"
        sheetElementId="AACChromePortal"
        closeButton={{
          type: "icon",
          label: "close",
        }}
      >
        <MobileSheetContentContainer>
          <MobileCloseBtnContainer>
            <Button onClick={handleClose} transparent>
              <MobileCloseIcon
                type={pageDirection === "rtl" ? angleRight : angleLeft}
              />
              <MobileCloseBtnText>{cancelLabel}</MobileCloseBtnText>
            </Button>
          </MobileCloseBtnContainer>
          <AccountInfoCard
            accountType={selectedAccountType}
            accountName={selectedAccount?.label}
            entityId={selectedAccount?.entityId}
          />
          <MobileListComponentContainer>
            {countryLinksWithRegionArr.map((countryLinksWithRegion) => {
              return (
                <CountryLinksSection
                  key={countryLinksWithRegion.region}
                  countryLinksWithRegion={countryLinksWithRegion}
                />
              );
            })}
          </MobileListComponentContainer>
        </MobileSheetContentContainer>
      </Sheet>
    </ThemeProvider>
  );
};